<script setup lang="ts"></script>
<template>
  <div class="h-screen overflow-hidden bg-gray-100">
    <slot />
  </div>
</template>
